// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";

function toString(json, field) {
  return Belt_Option.getWithDefault(Belt_Option.flatMap(Js_json.decodeObject(json), (function (dict) {
                    return Belt_Option.flatMap(Js_dict.get(dict, field), Js_json.decodeString);
                  })), "");
}

function toInt(json, field) {
  return Belt_Option.getWithDefault(Belt_Option.flatMap(Js_json.decodeObject(json), (function (dict) {
                    return Belt_Option.map(Belt_Option.flatMap(Js_dict.get(dict, field), Js_json.decodeNumber), (function (prim) {
                                  return prim | 0;
                                }));
                  })), 0);
}

function toOptionString(json, field) {
  return Belt_Option.flatMap(Js_json.decodeObject(json), (function (dict) {
                return Belt_Option.flatMap(Js_dict.get(dict, field), Js_json.decodeString);
              }));
}

function toOptionInt(json, field) {
  return Belt_Option.flatMap(Js_json.decodeObject(json), (function (dict) {
                return Belt_Option.map(Belt_Option.flatMap(Js_dict.get(dict, field), Js_json.decodeNumber), (function (prim) {
                              return prim | 0;
                            }));
              }));
}

function toOptionFloat(json, field) {
  return Belt_Option.flatMap(Js_json.decodeObject(json), (function (dict) {
                return Belt_Option.flatMap(Js_dict.get(dict, field), Js_json.decodeNumber);
              }));
}

function toOptionJson(json, field) {
  return Belt_Option.flatMap(Belt_Option.flatMap(Js_json.decodeObject(json), (function (dict) {
                    return Js_dict.get(dict, field);
                  })), (function (resultJson) {
                var match = Js_json.classify(resultJson);
                if (typeof match === "number" && match >= 2) {
                  return ;
                } else {
                  return Caml_option.some(resultJson);
                }
              }));
}

function toOptionArrayJson(json, field) {
  return Belt_Option.map(Belt_Option.flatMap(Belt_Option.flatMap(Js_json.decodeObject(json), (function (dict) {
                        return Js_dict.get(dict, field);
                      })), Js_json.decodeArray), (function (resultJson) {
                return Belt_Array.keepMap(resultJson, (function (resultJson) {
                              var match = Js_json.classify(resultJson);
                              if (typeof match === "number" && match >= 2) {
                                return ;
                              } else {
                                return Caml_option.some(resultJson);
                              }
                            }));
              }));
}

var Decode = {
  toString: toString,
  toInt: toInt,
  toOptionString: toOptionString,
  toOptionInt: toOptionInt,
  toOptionFloat: toOptionFloat,
  toOptionJson: toOptionJson,
  toOptionArrayJson: toOptionArrayJson
};

export {
  Decode ,
}
/* No side effect */
